var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8888_44227",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "url(#pattern0_8888_44227)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8888_44227)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "url(#pattern1_8888_44227)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "#018D47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_8888_44227",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8888_44227",
    transform: "matrix(0.01 0 0 0.00923077 0 0.0384615)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_8888_44227",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8888_44227",
    transform: "matrix(0.01 0 0 0.00923077 0 0.0384615)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8888_44227",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.93eb2b23f862dcf759f17300100608ee.svg";
export { ForwardRef as ReactComponent };